(function () {
  if (window.UqoraCampaignOffers) return;

  const STORAGE_KEY = "uqoraCampaignOffer";
  const SESSION_SYNC_KEY = "uqoraCampaignOfferCartSync";
  const PREVIEW_STORAGE_KEY = "uqoraCampaignOfferPreview";
  const CART_ATTRIBUTE_KEY = "_uqora_gwp_campaign";
  const STATE_UPDATED_EVENT = "uqora:campaign-offer-updated";

  const OFFERS = {
    labor_day_sale_2026: {
      key: "labor_day_sale_2026",
      campaignParameter: "labor_day_sale_2026",
      startsAt: "2026-08-26T17:40:26.000Z",
      endsAt: "2026-09-08T17:40:40.000Z",
      discountCode: "LABORDAY",
      discountPercentage: 15,
      giftVariantId: 31782670336058,
      excludedProductHandleFamilies: [
        "wash",
        "wipes",
        "cleansing-wipes",
        "emergency-kit",
        "uti-emergency-kit",
      ],
    },
  };

  let activeOffer = null;
  let pendingCartUpdate = null;
  let expirationTimer = null;
  let cartAttributeReady = false;
  let cartHasAnyGwp = false;
  let activeOfferPreview = false;
  let serverTimeOffsetMs = 0;
  let serverTimeReady = false;

  const readStorage = (storage, key) => {
    try {
      return storage.getItem(key);
    } catch (_) {
      return null;
    }
  };

  const writeStorage = (storage, key, value) => {
    try {
      storage.setItem(key, value);
      return true;
    } catch (_) {
      return false;
    }
  };

  const removeStorage = (storage, key) => {
    try {
      storage.removeItem(key);
    } catch (_) {}
  };

  const getCartUpdateUrl = () => {
    const root = window.Shopify?.routes?.root || "/";
    return `${root}cart/update.js`;
  };

  const getCartUrl = () => {
    const root = window.Shopify?.routes?.root || "/";
    return `${root}cart.js`;
  };

  const updateGiftClaimFromCart = (cart, offer) => {
    if (!cart || !Array.isArray(cart.items)) return;
    const claimedKey = `uqora_gwp_claimed_${offer.key}`;
    cartHasAnyGwp = cart.items.some((item) => item.properties?._gwp_uqora === "true");
    const hasCampaignGift = cart.items.some(
      (item) => item.properties?._gwp_campaign === offer.key
    );
    if (hasCampaignGift) {
      writeStorage(window.localStorage, claimedKey, "true");
    } else {
      removeStorage(window.localStorage, claimedKey);
    }
  };

  const getTrustedNow = () => Date.now() + serverTimeOffsetMs;

  const recordServerTime = (response) => {
    const serverDate = response?.headers?.get?.("Date");
    const parsedServerTime = Date.parse(serverDate || "");
    if (!Number.isFinite(parsedServerTime)) return false;
    serverTimeOffsetMs = parsedServerTime - Date.now();
    serverTimeReady = true;
    return true;
  };

  const isWithinWindow = (offer, now = getTrustedNow()) => {
    return now >= Date.parse(offer.startsAt) && now < Date.parse(offer.endsAt);
  };

  const isOfferTimingReady = (offer) =>
    activeOfferPreview || (serverTimeReady && isWithinWindow(offer));

  const enableOfferDiscount = (offer) => {
    window.UqoraAutoDiscount?.setConfig({
      enabled: true,
      code: offer.discountCode,
      percentage: offer.discountPercentage,
    });
  };

  const isThemePreview = () => {
    return Boolean(
      window.Shopify?.designMode ||
      (document.documentElement.dataset.uqoraThemeRole &&
        document.documentElement.dataset.uqoraThemeRole !== "main") ||
      document.getElementById("PBarNextFrame") ||
      ["127.0.0.1", "localhost"].includes(window.location.hostname)
    );
  };

  const getPreviewOffer = (queryParams) => {
    if (!isThemePreview()) return null;
    const previewKey = queryParams.get("uqora_campaign_preview");
    return previewKey ? OFFERS[previewKey] || null : null;
  };

  const persistOffer = (offer) => {
    writeStorage(
      window.localStorage,
      STORAGE_KEY,
      JSON.stringify({ key: offer.key, expiresAt: offer.endsAt })
    );
  };

  const readStoredOffer = () => {
    const raw = readStorage(window.localStorage, STORAGE_KEY);
    if (!raw) return null;

    try {
      const stored = JSON.parse(raw);
      const offer = OFFERS[stored.key];
      if (!offer || stored.expiresAt !== offer.endsAt) return null;
      return offer;
    } catch (_) {
      return null;
    }
  };

  const syncCartAttribute = (offer, { force = false } = {}) => {
    if (!offer) return Promise.resolve(false);
    if (pendingCartUpdate) return pendingCartUpdate;

    const operation = (async () => {
      const sessionMatches =
        !force && readStorage(window.sessionStorage, SESSION_SYNC_KEY) === offer.key;

      if (sessionMatches) {
        try {
          const cartResponse = await fetch(getCartUrl());
          if (cartResponse.ok) {
            recordServerTime(cartResponse);
            const cart = await cartResponse.json();
            cartAttributeReady = cart.attributes?.[CART_ATTRIBUTE_KEY] === offer.key;
            updateGiftClaimFromCart(cart, offer);
            if (cartAttributeReady && isOfferTimingReady(offer)) {
              enableOfferDiscount(offer);
              if (!activeOfferPreview) scheduleExpiration(offer);
              return true;
            }
            if (cartAttributeReady && !isOfferTimingReady(offer)) {
              cartAttributeReady = false;
              window.setTimeout(() => {
                if (activeOffer?.key === offer.key) deactivateOffer();
              }, 0);
              return false;
            }
          }
        } catch (error) {
          console.warn("uqora campaign offer: cart verification failed", error);
        }
      }

      try {
        const response = await fetch(getCartUpdateUrl(), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: { [CART_ATTRIBUTE_KEY]: offer.key },
          }),
        });
        if (!response.ok) {
          throw new Error(`cart attribute update failed: ${response.status}`);
        }

        recordServerTime(response);
        const cart = await response.json();
        cartAttributeReady = cart.attributes?.[CART_ATTRIBUTE_KEY] === offer.key;
        updateGiftClaimFromCart(cart, offer);
        if (!cartAttributeReady) {
          throw new Error("cart attribute update was not reflected in the cart");
        }
        if (!isOfferTimingReady(offer)) {
          cartAttributeReady = false;
          window.setTimeout(() => {
            if (activeOffer?.key === offer.key) deactivateOffer();
          }, 0);
          return false;
        }

        writeStorage(window.sessionStorage, SESSION_SYNC_KEY, offer.key);
        enableOfferDiscount(offer);
        if (!activeOfferPreview) scheduleExpiration(offer);
        return true;
      } catch (error) {
        cartAttributeReady = false;
        removeStorage(window.sessionStorage, SESSION_SYNC_KEY);
        console.warn("uqora campaign offer: cart attribute update failed", error);
        if (activeOffer?.key === offer.key) deactivateOffer();
        return false;
      }
    })();

    let trackedOperation;
    trackedOperation = operation.finally(() => {
      if (pendingCartUpdate === trackedOperation) pendingCartUpdate = null;
    });
    pendingCartUpdate = trackedOperation;

    return pendingCartUpdate;
  };

  const clearCampaignCartState = async (offer) => {
    if (!offer) return true;

    try {
      const cartResponse = await fetch(getCartUrl());
      if (!cartResponse.ok) {
        throw new Error(`cart read failed: ${cartResponse.status}`);
      }
      const cart = await cartResponse.json();
      const updates = {};
      cart.items
        .filter((item) => item.properties?._gwp_campaign === offer.key)
        .forEach((item) => {
          updates[item.key] = 0;
        });

      const body = {
        attributes: { [CART_ATTRIBUTE_KEY]: "" },
      };
      if (Object.keys(updates).length) body.updates = updates;

      const response = await fetch(getCartUpdateUrl(), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      if (!response.ok) {
        throw new Error(`campaign cart cleanup failed: ${response.status}`);
      }

      const updatedCart = await response.json();
      cartAttributeReady = false;
      updateGiftClaimFromCart(updatedCart, offer);
      removeStorage(window.sessionStorage, SESSION_SYNC_KEY);
      return true;
    } catch (error) {
      console.warn("uqora campaign offer: cart cleanup failed", error);
      return false;
    }
  };

  const queueCampaignCartCleanup = (offer) => {
    if (!offer) return Promise.resolve(true);
    const previousUpdate = pendingCartUpdate;
    const operation = (async () => {
      if (previousUpdate) await previousUpdate;
      return clearCampaignCartState(offer);
    })();

    let trackedOperation;
    trackedOperation = operation.finally(() => {
      if (pendingCartUpdate === trackedOperation) pendingCartUpdate = null;
    });
    pendingCartUpdate = trackedOperation;
    return trackedOperation;
  };

  const copyOffer = (offer) =>
    offer
      ? {
          ...offer,
          excludedProductHandleFamilies: [...offer.excludedProductHandleFamilies],
        }
      : null;

  const belongsToExcludedProductFamily = (handle, offer) =>
    offer.excludedProductHandleFamilies.some(
      (family) => handle === family || handle.startsWith(`${family}-`)
    );

  const emitState = () => {
    const detail = { activeOffer: copyOffer(activeOffer) };
    document.documentElement.toggleAttribute("data-uqora-campaign-active", Boolean(activeOffer));
    if (activeOffer) {
      document.documentElement.dataset.uqoraCampaign = activeOffer.key;
    } else {
      delete document.documentElement.dataset.uqoraCampaign;
    }
    window.dispatchEvent(new CustomEvent(STATE_UPDATED_EVENT, { detail }));
  };

  const getAutomaticGift = ({ productHandle } = {}) => {
    if (!activeOffer || !cartAttributeReady || cartHasAnyGwp) return null;

    const normalizedHandle = String(productHandle || "").trim().toLowerCase();
    if (!normalizedHandle) return null;
    if (belongsToExcludedProductFamily(normalizedHandle, activeOffer)) return null;

    const claimedKey = `uqora_gwp_claimed_${activeOffer.key}`;
    if (readStorage(window.localStorage, claimedKey) === "true") return null;

    return {
      variantId: activeOffer.giftVariantId,
      campaign: activeOffer.key,
    };
  };

  const appendGiftLine = ({
    items,
    productHandle,
    selectedVariantId,
    selectedCampaign,
    createBundleId,
  } = {}) => {
    if (!Array.isArray(items) || !items[0]) return { included: false };

    const automaticGift = getAutomaticGift({ productHandle });
    const variantId = automaticGift?.variantId || selectedVariantId;
    const campaign = automaticGift?.campaign || selectedCampaign || null;
    if (!variantId) return { included: false };

    const bundleId = createBundleId?.();
    if (!bundleId) return { included: false };

    items[0].properties = {
      ...(items[0].properties || {}),
      _gwp_bundle_id: bundleId,
    };
    items.push({
      id: variantId,
      quantity: 1,
      properties: {
        _gwp_uqora: "true",
        _gwp_bundle_id: bundleId,
        ...(campaign && { _gwp_campaign: campaign }),
      },
    });

    return { included: true, campaign, variantId };
  };

  const createBundleId = () => {
    if (window.crypto?.randomUUID) return `gwp_${window.crypto.randomUUID()}`;
    return `gwp_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  };

  const buildAutomaticGiftCartAddPayload = ({ formData, productHandle } = {}) => {
    if (!formData?.get || !formData?.entries) return null;

    const sellingPlan = formData.get("selling_plan");

    const variantId = Number(formData.get("id"));
    const quantity = Number(formData.get("quantity") || 1);
    if (!Number.isFinite(variantId) || variantId <= 0) return null;
    if (!Number.isFinite(quantity) || quantity <= 0) return null;

    const properties = {};
    for (const [name, value] of formData.entries()) {
      const match = /^properties\[(.+)\]$/.exec(name);
      if (match && value !== "") properties[match[1]] = value;
    }

    const items = [
      {
        id: variantId,
        quantity,
        ...(sellingPlan && { selling_plan: Number(sellingPlan) || sellingPlan }),
        ...(Object.keys(properties).length && { properties }),
      },
    ];
    const giftResult = appendGiftLine({
      items,
      productHandle,
      createBundleId,
    });
    if (!giftResult.included || !giftResult.campaign) return null;

    const sections = formData.get("sections");
    const sectionsUrl = formData.get("sections_url");
    return {
      items,
      ...(sections && { sections }),
      ...(sectionsUrl && { sections_url: sectionsUrl }),
    };
  };

  const ensureActiveOfferCartState = async () => {
    if (!activeOffer) return true;
    if (pendingCartUpdate) await pendingCartUpdate;
    if (!activeOffer) return false;
    if (!isOfferTimingReady(activeOffer)) {
      deactivateOffer();
      return false;
    }
    // Always refresh the cart before an add. Another tab or Rebuy may have
    // claimed a GWP after campaign initialization; a current cart read keeps
    // the atomic add helper from appending a second gift.
    return syncCartAttribute(activeOffer, { force: true });
  };

  const deactivateOffer = () => {
    const previousOffer = activeOffer;
    activeOffer = null;
    activeOfferPreview = false;
    if (expirationTimer) {
      window.clearTimeout(expirationTimer);
      expirationTimer = null;
    }
    cartAttributeReady = false;
    removeStorage(window.localStorage, STORAGE_KEY);
    removeStorage(window.sessionStorage, SESSION_SYNC_KEY);
    let cleanupPromise = Promise.resolve(true);
    if (previousOffer) {
      removeStorage(window.localStorage, `uqora_gwp_claimed_${previousOffer.key}`);
      cleanupPromise = queueCampaignCartCleanup(previousOffer);
    }

    const discountConfig = window.UqoraAutoDiscount?.getConfig?.();
    if (previousOffer && discountConfig?.code === previousOffer.discountCode) {
      cleanupPromise.finally(() => {
        window.UqoraAutoDiscount.setConfig({ enabled: false });
      });
    }
    emitState();
  };

  const scheduleExpiration = (offer) => {
    if (expirationTimer) window.clearTimeout(expirationTimer);
    const delay = Date.parse(offer.endsAt) - getTrustedNow();
    if (delay <= 0) return;
    expirationTimer = window.setTimeout(deactivateOffer, delay);
  };

  const activateOffer = (offer, { persist = true, preview = false } = {}) => {
    activeOffer = offer;
    activeOfferPreview = preview;
    cartAttributeReady = false;
    if (persist) persistOffer(offer);
    syncCartAttribute(offer);
    emitState();
    return copyOffer(offer);
  };

  const initialize = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const previewOffer = getPreviewOffer(queryParams);
    if (previewOffer) {
      writeStorage(window.sessionStorage, PREVIEW_STORAGE_KEY, previewOffer.key);
      activateOffer(previewOffer, { persist: false, preview: true });
      return;
    }

    if (isThemePreview()) {
      const previewKey = readStorage(window.sessionStorage, PREVIEW_STORAGE_KEY);
      const persistedPreviewOffer = previewKey ? OFFERS[previewKey] || null : null;
      if (persistedPreviewOffer) {
        activateOffer(persistedPreviewOffer, { persist: false, preview: true });
        return;
      }
    } else {
      removeStorage(window.sessionStorage, PREVIEW_STORAGE_KEY);
    }

    const campaignParameter = (queryParams.get("utm_campaign") || "").trim().toLowerCase();
    const linkedOffer = Object.values(OFFERS).find(
      (offer) => offer.campaignParameter.toLowerCase() === campaignParameter
    );
    if (linkedOffer) {
      activateOffer(linkedOffer);
      return;
    }

    const storedOffer = readStoredOffer();
    if (storedOffer) {
      activateOffer(storedOffer, { persist: false });
      return;
    }

    const syncedOfferKey = readStorage(window.sessionStorage, SESSION_SYNC_KEY);
    const staleOffer = storedOffer || OFFERS[syncedOfferKey] || null;
    removeStorage(window.localStorage, STORAGE_KEY);
    removeStorage(window.sessionStorage, SESSION_SYNC_KEY);
    if (staleOffer) queueCampaignCartCleanup(staleOffer);
    emitState();
  };

  window.UqoraCampaignOffers = {
    events: { stateUpdated: STATE_UPDATED_EVENT },
    getActiveOffer: () => copyOffer(activeOffer),
    isActive: (key) => activeOffer?.key === key,
    getAutomaticGift,
    appendGiftLine,
    buildAutomaticGiftCartAddPayload,
    ensureCartAttribute: ensureActiveOfferCartState,
    syncCartAttribute: () => syncCartAttribute(activeOffer, { force: true }),
    get pendingCartUpdate() {
      return pendingCartUpdate;
    },
  };

  document.addEventListener("gwp:claimed", () => {
    if (!activeOffer) return;
    cartHasAnyGwp = true;
    writeStorage(window.localStorage, `uqora_gwp_claimed_${activeOffer.key}`, "true");
  });

  document.addEventListener("gwp:cart-updated", (event) => {
    cartHasAnyGwp = Boolean(event.detail?.hasGwp);
    if (!activeOffer || cartHasAnyGwp) return;
    removeStorage(window.localStorage, `uqora_gwp_claimed_${activeOffer.key}`);
  });

  initialize();
})();
